import { useContext } from "react";
import UserDataPreferenceForm from "../UserDataPreferenceForm";
import { UserDataPreferenceContext } from "..";
import Styles from '../Styles.module.css'

export default function CallDistributionOptInView(){
  const { setTitle } = useContext(UserDataPreferenceContext);
  setTitle("Consumer Call Center Data - Opt Back Into Voice Biometric Data for AI Training Purposes")

  return (
    <>
      <p>
        To opt back into CURE sharing voice biometric data with third parties for AI training purposes, 
        please enter your first name, last name and the phone number from which you called CURE and click submit.
      </p>
      <p>
        For more information about our Privacy Notice, <a href="/privacy-policy" className={Styles.link}>click here</a>.
      </p>
      <h5 style={{marginBottom: "5px"}}>Caller Information</h5>
      <UserDataPreferenceForm 
        successMessage={"You have been opted-in. Thank you."} 
        dataType="Call Distribution" 
        status="Opt In"
      />
    </>
  )
}